import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/footer/part_canope.png")